<ng-container *ngIf="lastSaved">
    <div class="flex">
        <div class="autosave-checkmark"><i class="big green check circle icon"></i></div>
        <div class="autosave-info">
            <div class="autosave-info__title">{{ 'performance.autosaveInfo.saved' | translate }}</div>
            <div class="autosave-info__time">
                {{ 'performance.autosaveInfo.time' | translate: { lastSaved: lastSaved | appDate: 'shortTime' } }}
            </div>
        </div>
    </div>
</ng-container>
